/* Header account dropdown.
   <details> already handles opening on click. This only adds the two things it
   does not do on its own: close when you click somewhere else, and close on
   Escape. Delegated from document so it survives the header being re-rendered
   in the theme editor. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('details.custom-account-menu[open]').forEach(function (menu) {
      if (menu !== except) {
        menu.removeAttribute('open');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var inside = event.target.closest('details.custom-account-menu');
    closeAll(inside);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAll(null);
    }
  });
})();
